import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/logos/session-logo_dark.svg")